import React, { FormEvent, useState, useEffect } from 'react'
import { useForm } from '../hooks/form/useForm'
import { mappingService } from '../services/mappingService'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
const logo = require('../assets/images/esl-logo-black.png')
const domainTooltip = require('../assets/images/domain.jpg')
const { Button } = require('monday-ui-react-core')
interface FreshAccountFormProps {
  mapping: Mapping
  setMapping: React.Dispatch<React.SetStateAction<Mapping | undefined>>
  openedFromMapping?: boolean | undefined
  setNavigation?: React.Dispatch<React.SetStateAction<string>>
  setFreshError?: React.Dispatch<React.SetStateAction<boolean>>
  accessToken: string
}

export const FreshAccountForm: React.FC<FreshAccountFormProps> = ({ mapping, setMapping, openedFromMapping, setNavigation, setFreshError, accessToken }) => {
  const [freshAccount, handleChange] = useForm({
    freshApiKey: mapping.freshApiKey,
    freshDomain: mapping.freshDomain,
    ticketType: mapping.ticketType,
  })
  const [passwordType, setPasswordType] = useState<string>('password')

  const handleSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault()
    const newMapping: Mapping = {
      ...mapping,
      freshDomain: freshAccount.freshDomain,
      freshApiKey: freshAccount.freshApiKey,
      ticketType: freshAccount.ticketType,
    }
    setMapping(newMapping)
    await mappingService.saveMapping(newMapping, accessToken)
    setNavigation && setNavigation('Home')
  }

  useEffect(() => {
    setFreshError && setFreshError(false)
  }, [])

  const revealPassword = async (): Promise<void> => {
    if (passwordType === 'password') {
      setPasswordType('text')
      return
    }
    setPasswordType('password')
  }

  return (
    <section className={'form-container'}>
      <h1 className="app-title">E.S.L's FreshService Integration</h1>
      <form className="login-form">
        <div className="inputs-container">
          <label>
            Domain:
            <input required className="login-input" type="text" onChange={handleChange} name="freshDomain" value={freshAccount.freshDomain} placeholder="my-domain.freshservice.com" />
            <div className="tooltip">
              <span>
                <FontAwesomeIcon icon={faCircleInfo} />
              </span>
              <div className="tooltip-container">
                <img src={domainTooltip} alt="domain-tooltip" />
                Enter your Freshservice subdomain.
              </div>
            </div>
          </label>
          <label>
            API Key:
            <input required className="login-input" type={passwordType} onChange={handleChange} name="freshApiKey" value={freshAccount.freshApiKey} placeholder="Enter your API key" />
            <span className="reveal-password" onClick={() => revealPassword()}>
              {passwordType === 'password' ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
            </span>
            <div className="tooltip">
              <span>
                <FontAwesomeIcon icon={faCircleInfo} />
              </span>
              <div className="tooltip-container">{'Profile > Profile Settings > Your API Key'}</div>
            </div>
          </label>
          <div className="radio-container">
            <label>
              <input checked={freshAccount.ticketType === 'ticket'} type="radio" onChange={handleChange} name="ticketType" value="ticket" />
              Ticket
            </label>
            <label>
              <input checked={freshAccount.ticketType === 'serviceRequest'} type="radio" onChange={handleChange} name="ticketType" value="serviceRequest" />
              Service Request
            </label>
          </div>
        </div>
        <div className="actions">
          <Button disabled={!freshAccount.ticketType || !freshAccount.freshDomain || !freshAccount.freshApiKey} onClick={(event: FormEvent) => handleSubmit(event)}>
            {openedFromMapping ? 'Submit' : 'Login'}
          </Button>
        </div>
      </form>
      <footer>
        <img src={logo} alt="logo" />
        <span className="contact-us">
          Contact us: <a href="mailto:appsupport@eswlab.com">appsupport@eswlab.com</a>
        </span>
      </footer>
    </section>
  )
}
